var review_slide = new Swiper('.review_slide', {
    slidesPerView: 1.15, 
    spaceBetween: 16, 
  navigation: {
        nextEl: ".review-next",
        prevEl: ".review-prev",
    },
  observer: true,
  observeParents: true,

    breakpoints: { //반응형 조건 속성
   
      768: {
        slidesPerView: 3.2,
      },
      1024: {
        slidesPerView: 4,
      },
    }
});
